<template>
  <div>
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <p style="margin: 0;margin-left: -22px;" class="goodslist1">
          <span style="margin-left:31px;margin-top:5px">搜索/查询</span>
          <span class="goods_red"/>
        </p>
        <div style="position: absolute;right:-19px;top:-10px" class="sanjiao"></div>
      </div>
      <el-collapse-transition>
        <div style="padding:0 12px" v-show="show3">
          <el-form
            :inline="true"
            :model="formInline"
            class="demo-form-inline findform"
            style="display:flex;margin-top:10px;height:55px"
          >
            <el-form-item style="width:100%;display:flex" label="活动栏目：">
              <el-input v-model="name" placeholder="请输入活动栏目名称" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item style="display:flex;width:100%" label="所属城市：">
              <!-- <el-button style="float:right;height:36px;line-height:1px" @click="onSubmit" class="toolbar_search">查询</el-button> -->
              <el-cascader
                placeholder="请选择城市"
                :options="options"
                style="width:100%"
                filterable
                change-on-select
                @change="handleChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item
              style="display:flex;width:100%;margin-left:30px;"
              label="商品品类："
              class="select"
            >
              <el-select
                filterable
                v-model="filters.brandTypeId"
                placeholder="请选择"
                style="background:#fff;width:100%"
                ref="mySelect"
                @change="getbrandarr"
              >
                <el-option
                  :label="item.Name"
                  :value="item.Id"
                  v-for="(item,index) in brandTypearr"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-form
            :inline="true"
            :model="formInline"
            class="demo-form-inline findform"
            style="display:flex;margin-top:10px;height:55px"
          >
            <el-form-item style="display:flex;width:33.3%;" label="商品品牌：" class="select">
              <el-select
                filterable
                v-model="filters.brandId"
                placeholder="请选择"
                style="background:#fff;width:100%"
                ref="mySelect1"
              >
                <el-option
                  :label="item.Name"
                  :value="item.Id"
                  v-for="(item,index) in brandarr"
                  :key="index"
                ></el-option>
                <!-- <el-option label="小程序" value="beijing"></el-option> -->
              </el-select>
            </el-form-item>
            <el-form-item style="display:flex;width:33.3%;" label="状　　态：" class="select">
              <el-select v-model="stateId" filterable ref="mySelect1" placeholder="请选择"
                style="background:#fff;width:100%">
                <el-option v-for="(item,index) in statearr" :key="index" :value="item.Id" :label="item.Name"/>
                <!-- <el-option label="小程序" value="beijing"></el-option> -->
              </el-select>
            </el-form-item>
             <el-form-item style="display:flex;width:33.3%;margin-left:30px;" class="select">
             <el-button type="danger" @click="findinfo()" style="float:right">查 询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <!-- 列表区域 -->
    <div class="banner">
      <el-col :span="18" style>
        <p style="margin-left:8px" class="model_top_title">快捷操作</p>
        <div style="display:flex;margin-left:8px;margin-top:15px;border-bottom: 1px solid #eee;padding-bottom:15px">
          <p @click="showAdd()" style="margin:0px;margin-right:10px" class="add_new_btn butstyle">新增栏目</p>
          <p @click="opencolmn(1)" style="margin:0px;margin-right:10px" class="add_new_btn butstyle">开 启</p>
          <p @click="opencolmn(0)" style="margin:0px;margin-right:10px" class="add_new_btn butstyle">关 闭</p>
          <p @click="deletegoods()" style="margin:0px;margin-right:10px" class="add_new_btn butstyle">删 除</p>
          <!-- <p @click="OpenShop(2)" style="margin:0px;margin-right:20px" class="add_new_btn butstyle">闭 店</p>
                <p @click="cateShop(1)" style="margin:0px;margin-right:20px" class="add_new_btn butstyle">认 证</p>
                <p @click="cateShop(2)" style="margin:0px;margin-right:20px" class="add_new_btn butstyle">取消认证</p>
          <p  style="margin:0px" @click="hezuochange" class="add_new_btn butstyle">设置合作模式</p>-->
        </div>
      </el-col>
      <el-col :span="18" style>
        <p style="margin-left:8px" class="model_top_title">栏目管理</p>
      </el-col>
      <div class="table_container">
        <div class="tabler_inner_container">
          <el-table
            :header-cell-style="{background:'#bbbbbb'}"
            :data="users"
            class="ban_tab"
            stripe
            border
            style="height:auto;margin-left:-14px;margin-top:10px"
            @selection-change="handleSelectionChange"
          >
            <!-- <el-table-column width="34" label="序号" align="center">
                  <template scope="scope">
                    <span>{{scope.$index + 1}}</span>
                  </template>
            </el-table-column>-->
            <el-table-column type="selection" align="center" width="55"></el-table-column>
            <el-table-column prop="Name" label="栏目名称" align="center">
              <template scope="scope">
                <span
                  :title="scope.row.Name"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                >{{scope.row.Name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="CityName" label="所属城市" align="center">
              <template scope="scope">
                <span
                  :title="scope.row.CityName"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                >{{scope.row.CityName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="SortNumber" label="顺序" align="center">
              <template scope="scope">
                <span
                  :title="scope.row.SortNumber"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                >{{scope.row.SortNumber}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="OpenName" label="状态" align="center">
              <template scope="scope">
                <span
                  :title="scope.row.OpenName"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                >{{scope.row.OpenName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="GoodsCounts" label="商品数量" align="center">
              <template scope="scope">
                <span
                  :title="scope.row.GoodsCounts"
                  style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                >{{scope.row.GoodsCounts}}</span>
              </template>
            </el-table-column>
            <el-table-column prop label="操作" width="270px" fixed="right" align="center">
                <template scope="scope">
                  <!-- <el-switch
                  v-model="scope.row.IsVerification"
                  @change="Authentication(scope)"
                  active-color="#F56C6C"
                  inactive-color="#ddd"
                  inactive-text
                  ></el-switch>-->

                  <span
                    style="color:#6786b4;margin-left:8px;cursor: pointer;"
                    @click="offer(scope)">
                    <i class="el-icon-edit-outline"></i>
                    编辑
                  </span>
                  <span
                    style="color:#6786b4;margin-left:8px;cursor: pointer;"
                    @click="deleteone(scope)">
                    <i class="el-icon-delete"></i>
                    删除
                  </span>
                  <span
                    style="color:#6786b4;margin-left:8px;cursor: pointer;"
                    @click="upordown(0,scope)">
                    <i class="el-icon-upload2"></i>
                    向上
                  </span>
                  <span
                    style="color:#6786b4;margin-left:8px;cursor: pointer;"
                    @click="upordown(1,scope)">
                    <i class="el-icon-download"></i>
                    向下
                  </span>
                
                </template>
              </el-table-column>
          </el-table>
            <el-col :span="24" style="padding-top:10px;" class="toolbar_footer">
                <el-pagination
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :page-size="10"
                  :current-page="pageIndex"
                  :total="total"
                  style="float:right;margin-right:14px"/>
              </el-col>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { SelectBrandTypeBaseDataByCondition } from '../../api/newOss';
import { SelectGoodsBrandByBrandType, SelectGoodsColumnListByCondition,
  DeleteGoodsColumn, OpenOrCloseGoodsColumn, UpdateGoodsColumnSortNumber } from "../../api/api";
export default {
  name: "Activitycolumn",
  data() {
    return {
      pageIndex:1,
      stateId: -1,
      show3: false,
      users:[],
      goodIdarr:[],
      name: "",
      total:1,
      provinceId: 0,
      cityId: 0,
      tbdcity: [],
      tbdprovince: [],
      formInline: {},
      brandTypearr: [],
      brandarr: [],
      filters: {
        brandTypeId: 0,
        brandId: 0
      },
      statearr: [
        {
          Id: -1,
          Name: "全部"
        },
        {
          Id: 0,
          Name: "已关闭"
        },
        {
          Id: 1,
          Name: "已开启"
        }
      ],
      optionsindex: "",
      options: [
        {
          value: 0,
          label: "全部"
        }
      ]
    };
  },
  methods: {
    findinfo(){
     this.getcolumlist();
    },
    //编辑栏目
    offer(scope){
      localStorage.hcId = scope.row.Id
       this.$router.push({
        path:"/Newproducts",
        query:{
          type:2,
          provinceId:scope.row.ProvinceId,
          cityId:scope.row.CityId,
          Name:scope.row.Name,
        }
      })
    },
    //新增栏目
    showAdd(){
      localStorage.hcId = 0
      this.$router.push({
        path:"/Newproducts",
        query:{
          type:1
        }
      })
    },
    //操作向上   向下
    upordown(val,scope){
       var obj = {
         userId:localStorage.Id,
         hcId:scope.row.Id,
         type:val
       }
       UpdateGoodsColumnSortNumber(obj).then(data=>{
         if(data.ResultCode == 1){
             this.$swal({
                type: "success",
                text:"操作成功"
              });
               this.getcolumlist()
         }
       })
    },
    //单条删除
    deleteone(scope){
      this.$swal({
      type:'warning',
      text: '重要信息，你确定要删除吗？',
      showCancelButton:true,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      }).then(res=>{
        if(res.value){
           this.goodIdarr = [];
           this.goodIdarr.push(scope.row.Id);
           if(this.users.length ==1){
             this.pageIndex = 1
           }
                 var obj = {
           userId:localStorage.Id,
           ids:this.goodIdarr.join(",")
         }
         DeleteGoodsColumn(obj).then(data=>{
           if(data.ResultCode == 1){
             this.$swal({
                type: "success",
                text:"操作成功"
              });
              if(this.goodIdarr.length == this.users.length){
                if( this.pageIndex>1){
                   this.pageIndex = this.pageIndex-1
                }else{
                    this.pageIndex = 1
                }
               
              }
               this.getcolumlist()
               
           }
         })
        }
      })
    },
    //批量开启关闭
    opencolmn(val){
        if(this.goodIdarr.length == 0){
           this.$swal({
           type:"warning",
           text:"请选择需要操作得栏目"
         })
        }else{
          var obj = {
            userId:localStorage.Id,
            operType:val,
            ids:this.goodIdarr.join(",")
          }
          OpenOrCloseGoodsColumn(obj).then(data=>{
            if(data.ResultCode == 1){
              this.$swal({
                type: "success",
                text:"操作成功"
              });
               this.getcolumlist()
            }
          })
        } 
    },
    //批量删除
    deletegoods(){
       if(this.goodIdarr.length == 0){
         this.$swal({
           type:"warning",
           text:"请选择需要操作得栏目"
         })
       }else{
           this.$swal({
      type:'warning',
      text: '重要信息，你确定要删除吗？',
      showCancelButton:true,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      }).then(res=>{
          if(res.value){
               var obj = {
           userId:localStorage.Id,
           ids:this.goodIdarr.join(",")
         }
         DeleteGoodsColumn(obj).then(data=>{
           if(data.ResultCode == 1){
             this.$swal({
                type: "success",
                text:"操作成功"
              });
              if(this.goodIdarr.length == this.users.length){
                if( this.pageIndex >1){
                   this.pageIndex = this.pageIndex-1
                }else{
                  this.pageIndex = 1
                }
                
              }
               this.getcolumlist()
               
           }
         })
           }
      })
       }
    },
    handleCurrentChange(val){
     this.pageIndex = val;
     this.getcolumlist()
    },
    getcolumlist(){
       var obj = {
        userId:localStorage.Id,
        name:this.name,
        provinceId:this.provinceId,
        cityId:this.cityId,
        brandTypeId:this.filters.brandTypeId,
        brandId:this.filters.brandId,
        isOpen:this.stateId,
        pageIndex:this.pageIndex,
        pageSize:10
       }
      SelectGoodsColumnListByCondition(obj).then(data=>{
         if(data.ResultCode == 1){
            this.users = data.ResultObj;
            this.total = data.RowsCount;
         }else{
           this.users = []
           this.total = 0
         }
      }) 
    },
    handleSelectionChange(val){
      this.goodIdarr = [];
      val.forEach(element => {
        this.goodIdarr.push(element.Id);
      });
    },
    //获取品类
    getBrandType() {
      var obj = {
        userId: localStorage.Id
      };
      SelectBrandTypeBaseDataByCondition(obj).then(data => {
        if (data.ResultCode == 1) {
          this.getbrandarr();
          this.brandTypearr = data.ResultObj;
          this.newpinleioptions = data.ResultObj;
          this.brandTypearr.unshift({
            Id: 0,
            Name: "全部"
          });
        }
      });
    },
    //获取品牌
    getbrandarr() {
      this.filters.brandId = 0;
      var obj = {
        userId: localStorage.Id,
        brandTypeId: this.filters.brandTypeId
      };
      SelectGoodsBrandByBrandType(obj).then(data => {
        if (data.ResultCode == 1) {
          this.brandarr = data.ResultObj;
          this.brandarr.unshift({
            Id: 0,
            Name: "全部"
          });
        }
      });
    },
  },
  mounted() {
    this.getBrandType();
    this.getcolumlist();
  },
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// Activitycolumn.vue?37528ff3